export const ROUTES = {
  HOME_PATH: "/",
  SIGNOUT_PATH: "/signout",
  LANDING_PATH: "/landing",
  ADMIN_PATH: "/clientportal",
  DIRECTOR_PATH: "/director",
  SEARCH_PATH: "/deals",
  STORE_BASE_PATH: "/store",
  STORE_PATH: ["/store/:StoreKey", "/store/offer/:OfferKey", "/store/location/:LocationKey"],
  TRAVEL_PATH: "/travel",
  HOTELS_PATH: "/travel/hotels",
  CARS_PATH: "/travel/cars",
  TRAVEL_MY_TRIPS_PATH: "/travel/trips",
  ACTIVITIES_PATH: "/travel/activities",
  PARKS_PATH: "/travel/parks",
  FLIGHTS_PATH: "/travel/flights",
  HELP_PATH: "/help",
  FAVORITES_PATH: "/favorites",
  SAVINGS_CALCULATOR_PATH: "/savings-calculator",
  ACCOUNT_PATH: "/account",
  TERMS_PATH: "/terms",
  GROCERY_COUPONS_PATH: "/grocery-coupons",
  REDIRECT_ROUTE: "/redirect",
  REDIRECT_SSO: "/sso_redirect",
  DEALS_FAQ: "/faq",
  RETAILER_PATH: "/retailer",
  EVENTS_PATH: "/travel/events",
  UNSUBSCRIBE_PATH: "/unsubscribe",
  PARKS_SEARCH_PATH: "/travel/parks_search",
};

export const SetStorePathKey = (key) => {
  return ROUTES.STORE_PATH[0].replace(":StoreKey", key);
};

export const SetOfferKeyPath = (key) => {
  return ROUTES.STORE_PATH[1].replace(":OfferKey", key);
};

export const SetLocationKeyPath = (key) => {
  return ROUTES.STORE_PATH[2].replace(":LocationKey", key);
};
